import { create } from 'zustand';
import { Command, HistoryEntry } from '../types/command';

// LocalStorage'dan geçmişi yükle
const loadHistoryFromStorage = (): HistoryEntry[] => {
  try {
    const storedHistory = localStorage.getItem('command-history');
    if (storedHistory) {
      return JSON.parse(storedHistory) as HistoryEntry[];
    }
  } catch (error) {
    console.error('Error loading history from localStorage', error);
  }
  return [];
};

interface CommandState {
  commands: Command[];
  history: HistoryEntry[];
  currentInput: string;
  historyIndex: number;
  isLoading: boolean;
  
  // İşlemler
  setCommands: (commands: Command[]) => void;
  setLoading: (isLoading: boolean) => void;
  setCurrentInput: (input: string) => void;
  addToHistory: (entry: HistoryEntry) => void;
  clearHistory: () => void;
  moveHistoryUp: () => void;
  moveHistoryDown: () => void;
}

export const useCommandStore = create<CommandState>((set, get) => ({
  commands: [],
  history: loadHistoryFromStorage(), // Başlangıçta localStorage'dan yükle
  currentInput: '',
  historyIndex: -1,
  isLoading: false,
  
  setCommands: (commands: Command[]) => set({ commands }),
  
  setLoading: (isLoading: boolean) => set({ isLoading }),
  
  setCurrentInput: (input: string) => set({ currentInput: input }),
  
  addToHistory: (entry: HistoryEntry) => {
    const history = [...get().history, entry];
    set({ history, historyIndex: -1 });
    
    // LocalStorage'a kaydet
    try {
      localStorage.setItem('command-history', JSON.stringify(history));
    } catch (error) {
      console.error('Error saving history to localStorage', error);
    }
  },
  
  clearHistory: () => {
    set({ history: [], historyIndex: -1 });
    
    // localStorage'dan da temizle
    try {
      localStorage.removeItem('command-history');
    } catch (error) {
      console.error('Error clearing history from localStorage', error);
    }
  },
  
  moveHistoryUp: () => {
    const { history, historyIndex } = get();
    
    if (history.length === 0) return;
    
    const newIndex = historyIndex === -1 
      ? history.length - 1 
      : Math.max(0, historyIndex - 1);
      
    set({ 
      historyIndex: newIndex,
      currentInput: history[newIndex].command
    });
  },
  
  moveHistoryDown: () => {
    const { history, historyIndex, currentInput } = get();
    
    if (historyIndex === -1) return;
    
    const newIndex = historyIndex + 1;
    
    if (newIndex >= history.length) {
      set({ historyIndex: -1, currentInput: '' });
    } else {
      set({ 
        historyIndex: newIndex,
        currentInput: history[newIndex].command
      });
    }
  }
})); 